import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.034 10.303 5.447 12.89a1.68 1.68 0 0 1-2.333 0 1.647 1.647 0 0 1 0-2.333L5.7 7.97a.67.67 0 1 0-.947-.947L2.167 9.617a2.987 2.987 0 0 0 4.22 4.22L8.98 11.25a.67.67 0 1 0-.946-.947m5.72-8.053a2.993 2.993 0 0 0-4.22 0L6.94 4.837a.67.67 0 0 0 .947.946l2.587-2.586a1.68 1.68 0 0 1 2.333 0 1.647 1.647 0 0 1 0 2.333L10.22 8.117a.666.666 0 0 0 0 .946.667.667 0 0 0 .947 0l2.587-2.593a2.993 2.993 0 0 0 0-4.22m-7.907 7.907a.67.67 0 0 0 .473.193.67.67 0 0 0 .474-.193l3.28-3.28a.67.67 0 1 0-.947-.947l-3.28 3.28a.667.667 0 0 0 0 .947"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })